/**
 * 카카오 로그인 유틸리티
 */
declare global {
  interface Window {
    Kakao: any
  }
}

const KAKAO_JS_KEY = process.env.REACT_APP_KAKAO_JS_KEY || ''

/**
 * 카카오 SDK 초기화
 */
const initKakaoSDK = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (window.Kakao) {
      if (window.Kakao.isInitialized()) {
        resolve()
        return
      }
      window.Kakao.init(KAKAO_JS_KEY)
      resolve()
      return
    }

    const script = document.createElement('script')
    // 임시: v1 URL 사용. (v2 마이그레이션은 다음 작업에서 카카오 공식 문서 확인 후 재시도.)
    // v1 지원 종료: 2026-12-31. 그 전까지 마이그레이션 필요.
    script.src = 'https://developers.kakao.com/sdk/js/kakao.js'
    script.async = true
    script.onload = () => {
      if (window.Kakao) {
        window.Kakao.init(KAKAO_JS_KEY)
        resolve()
      } else {
        reject(new Error('카카오 SDK를 로드할 수 없습니다.'))
      }
    }
    script.onerror = () => {
      reject(new Error('카카오 SDK 스크립트 로드에 실패했습니다.'))
    }
    document.head.appendChild(script)
  })
}

/**
 * 카카오 로그인 실행
 */
export const handleKakaoLogin = async (
  onSuccess: (providerId: string) => Promise<void>,
  onError: (error: string) => void
): Promise<void> => {
  try {
    await initKakaoSDK()

    if (!window.Kakao) {
      throw new Error('카카오 SDK가 초기화되지 않았습니다.')
    }

    window.Kakao.Auth.login({
      success: async (authObj: any) => {
        try {
          window.Kakao.API.request({
            url: '/v2/user/me',
            success: async (response: any) => {
              const kakaoId = response.id?.toString()

              if (!kakaoId) {
                onError('카카오 로그인 정보를 가져올 수 없습니다.')
                return
              }

              await onSuccess(kakaoId)
            },
            fail: () => {
              onError('카카오 사용자 정보를 가져오는데 실패했습니다.')
            },
          })
        } catch (error: any) {
          onError(error.message || '카카오 로그인 중 오류가 발생했습니다.')
        }
      },
      fail: (error: any) => {
        if (error.error === 'cancelled') {
          onError('카카오 로그인이 취소되었습니다.')
        } else {
          onError(
            error.error_description || '카카오 로그인 중 오류가 발생했습니다.'
          )
        }
      },
    })
  } catch (error: any) {
    onError(error.message || '카카오 로그인 중 오류가 발생했습니다.')
  }
}
